import { VFC } from "react";
import { Modal } from "antd";
import { LoadingComponent } from "./LoadingComponent";
import styled from "styled-components";

export const LoadingOverlay: VFC = () => {
  return (
    <StyledModal footer={null} width={"90%"} closable={false} visible={true}>
      <LoadingComponent />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-content {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
`;
